export const types = {
  SET_PASSWORD_REQUEST: 'auth/setPassword/SET_PASSWORD_REQUEST',
  SET_PASSWORD_SUCCESS: 'auth/setPassword/SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERROR: 'auth/setPassword/SET_PASSWORD_ERROR',
};

export const setPassword = {
  /**
   * @param {string} token
   * @param {string} data.password
   * @param {string} data.passwordConfirmation
   * @param {Function} cb
   */
  request: (key, data, cb) => ({
    type: types.SET_PASSWORD_REQUEST,
    payload: { key, data, cb },
  }),
  success: () => ({
    type: types.SET_PASSWORD_SUCCESS,
  }),
  error: (error) => ({
    type: types.SET_PASSWORD_ERROR,
    payload: error,
  }),
};
